import { baseClient, type ClientArgs } from 'shared/api/fetch'
import config from 'shared/config'
import toSnakeCase from 'snakecase-keys'
import toCamelCase from 'camelcase-keys'

interface IClientArgsWithToken extends Omit<ClientArgs, 'method'> {
  token: string
}

interface IClient {
  get: <T>(args: IClientArgsWithToken) => Promise<T>
  post: <T>(args: IClientArgsWithToken) => Promise<T>
  patch: <T>(args: IClientArgsWithToken) => Promise<T>
  put: <T>(args: IClientArgsWithToken) => Promise<T>
  del: <T>(args: IClientArgsWithToken) => Promise<T>
}

const API = config('INTERNAL_API_URL') as string

export default function client(config?: globalThis.RequestInit): IClient {
  const defaultConfig = {
    headers: { 'content-type': 'application/json' }
  }
  const baseConfig = {
    ...defaultConfig,
    ...config
  }

  interface TGetCustomArgs {
    headers: Record<string, string>
    data: object | null
    path: string
    responseHandler?: any
  }
  const getCustomArgs = (args: ClientArgs): TGetCustomArgs => {
    const headers: Record<string, string> = { ...defaultConfig.headers }
    if (args.token != null) {
      headers.Authorization = `Bearer ${args.token}`
    }
    return {
      path: `${API}${args.path}`,
      headers,
      data: args?.data != null ? { ...toSnakeCase(args.data, { deep: true }) } : null,
      responseHandler: {
        json: (response: any) => {
          if (args.rawResponse === true) {
            return toCamelCase(response, { deep: true })
          }
          return toCamelCase(response.data, { deep: true })
        }
      }
    }
  }

  return baseClient(baseConfig, getCustomArgs)
}
